<template>
  <div
    class="socialShareGroup"
    @click="onShowSubMenu"
  >
    <img :src="shareIcon" class="shareIcon"/>
    <div class="socialIcons" :style="{backgroundImage:'url('+require('../../assets/images/common/groupBack.svg')+')'}" v-show="this.showSubMenu">
      <a href="https://www.whatsapp.com/channel/0029VaMerIl8vd1K7xvJWl15" target="_blank">
        <img
          class="whatsapp"
          alt="whatsapp"
          :src="whatsapp"
        >
      </a>
      <a href="https://www.facebook.com/PGEbet/" target="_blank">
        <img
          class="facebook"
          alt="facebook"
          :src="facebook"
        >
      </a>
      <a href="https://t.me/PGEbet555" target="_blank">
        <img
          class="telegram"
          alt="telegram"
          :src="telegram"
        >
      </a>
    </div>
  </div>
</template>

<script>
import shareIcon from '@/assets/images/common/share.svg'
import whatsapp from '@/assets/images/common/shareWhatsApp.svg'
import telegram from '@/assets/images/common/shareTelegram.svg'
import facebook from '@/assets/images/common/shareFacebook.svg'
import {clickEvent} from '@/utils'

export default {
  name: 'SocialShareGroup',
  data () {
    return {
      shareIcon,
      whatsapp,
      telegram,
      facebook,
      showSubMenu: false
    }
  },
  methods: {
    onShowSubMenu () {
      clickEvent({EventNameEN: 'social'})
      this.showSubMenu = !this.showSubMenu
    }
  }
}
</script>

<style lang="less" scoped>
  .socialShareGroup {
    .shareIcon {
      position: relative;
      width: 60px;
      margin-right: -5px;
      height: 52px;
      z-index: 4;
    }

    span {
      color: black;
      font-size: 20px;
      letter-spacing: -3px;
      position: absolute;
      bottom: 50px;
      right: 95px;
    }

    .socialIcons {
      position: absolute;
      display: flex;
      align-items: center;
      bottom: 15px;
      right: 27px;
      width: 173px;
      height: 41px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      padding: 10px 0 6px 29px;
      z-index: 2;

      a {
        .whatsapp {
          width: 29px;
          height: 29px;
          margin-right: 8px;
        }
        .telegram {
          width: 33px;
          height: 33px;
          margin-right: 6px;
        }
        .facebook {
          width: 33px;
          height: 33px;
          margin-right: 6px;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SocialShareGroup/index.vue